(function(){
  function initGallery(root){
    var mainEl = root.querySelector('.pdp-main');
    var thumbsEl = root.querySelector('.pdp-thumbs');
    var galleryWrapEl = root.querySelector('.pdp__gallery');
    var detailsEl = root.querySelector('.pdp__details');
    if(!mainEl){ return; }

    var isMobile = function(){ return window.matchMedia('(max-width: 1023px)').matches; };
    // Desktop "carousel mode" forces the same Swiper-driven layout as mobile.
    var isCarouselMode = function(){
      return isMobile() || mainEl.classList.contains('pdp__main--carousel-desktop');
    };

    var announcer = root.querySelector('[data-pdp-announcer]');
    var loadMoreButton = root.querySelector('[data-gallery-load-more]');
    var swiper = null;
    var thumbs = null;
    var lastMode = null;
    var layoutFrame = null;
    var ds = root.dataset || {};

    function syncDetailsSticky(){
      if(!galleryWrapEl || !detailsEl){
        return;
      }

      root.classList.remove('pdp--details-sticky', 'pdp--gallery-sticky');
      detailsEl.style.removeProperty('--pdp-details-sticky-top');
      galleryWrapEl.style.removeProperty('--pdp-gallery-sticky-top');

      if(isMobile()){
        return;
      }

      var galleryHeight = galleryWrapEl.offsetHeight;
      var detailsHeight = detailsEl.offsetHeight;

      if(!galleryHeight || !detailsHeight || galleryHeight === detailsHeight){
        return;
      }

      var minTop = 84;
      var bottomGap = 24;

      if(detailsHeight < galleryHeight){
        var stickyTop = Math.min(minTop, window.innerHeight - detailsHeight - bottomGap);
        root.classList.add('pdp--details-sticky');
        detailsEl.style.setProperty('--pdp-details-sticky-top', stickyTop + 'px');
      } else {
        var stickyTop = Math.min(minTop, window.innerHeight - galleryHeight - bottomGap);
        root.classList.add('pdp--gallery-sticky');
        galleryWrapEl.style.setProperty('--pdp-gallery-sticky-top', stickyTop + 'px');
      }
    }

    function scheduleDetailsStickySync(){
      if(layoutFrame && window.cancelAnimationFrame){
        window.cancelAnimationFrame(layoutFrame);
      }

      if(window.requestAnimationFrame){
        layoutFrame = window.requestAnimationFrame(function(){
          layoutFrame = null;
          syncDetailsSticky();
        });
      } else {
        syncDetailsSticky();
      }
    }

    function destroySwiper(instance){
      if(instance && typeof instance.destroy === 'function'){
        instance.destroy(true, true);
      }
    }

    (function ensureThumbsUpdated(){
      if(!thumbsEl || !window.Swiper){ return; }
      try{
        var imgs = thumbsEl.querySelectorAll('.pdp-thumb__img');
        var remaining = imgs.length;
        if(remaining === 0){
          if(thumbs && typeof thumbs.update === 'function') thumbs.update();
          return;
        }
        function done(){
          remaining--;
          if(remaining <= 0 && thumbs && typeof thumbs.update === 'function'){
            thumbs.update();
          }
        }
        imgs.forEach(function(img){
          if(img.complete){ done(); }
          else {
            img.addEventListener('load', done, { once: true });
            img.addEventListener('error', done, { once: true });
          }
        });
      }catch(err){ /* noop */ }
    })();

    var effectMobile = ds.transitionMobile || 'slide';

    function createThumbs(){
      if(thumbs || !thumbsEl || !window.Swiper){ return; }
      thumbs = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        preloadImages: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
        breakpoints: {
          0: { spaceBetween: 6 },
          480: { spaceBetween: 8 }
        }
      });
    }

    function createMainSwiper(){
      if(swiper || !window.Swiper){ return; }

      var swiperParams = {
        slidesPerView: 1,
        speed: 300,
        allowTouchMove: true,
        keyboard: { enabled: true, onlyInViewport: true },
        observer: true,
        observeParents: true,
        preloadImages: true,
        effect: effectMobile,
        fadeEffect: { crossFade: true },
        on: {
          init: function(s){ updateUI(s, s.activeIndex); },
          imagesReady: function(s){ s.update(); updateUI(s, s.activeIndex); },
          slideChange: function(s){ updateUI(s, s.activeIndex); }
        }
      };

      var nextEl = root.querySelector('.swiper-button-next');
      var prevEl = root.querySelector('.swiper-button-prev');
      if (nextEl && prevEl) {
        swiperParams.navigation = {
          nextEl: nextEl,
          prevEl: prevEl
        };
      }

      swiper = new Swiper(mainEl, swiperParams);
    }

    if(thumbsEl){
      thumbsEl.addEventListener('click', function(e){
        if(!swiper) return;
        var btn = e.target.closest('.pdp-thumb');
        if(!btn) return;
        var idx = parseInt(btn.getAttribute('data-index'), 10);
        if(!isNaN(idx)) swiper.slideTo(idx);
      });
    }

    function updateUI(swiperInstance, index){
      if(announcer){
        var totalA = (swiperInstance && swiperInstance.slides && swiperInstance.slides.length) ||
          mainEl.querySelectorAll('.swiper-slide').length || 1;
        announcer.textContent = 'Image ' + (index+1) + ' of ' + totalA;
      }

      if(!thumbsEl) return;

      Array.prototype.forEach.call(thumbsEl.querySelectorAll('.pdp-thumb'), function(el){
        el.classList.remove('is-active');
        el.setAttribute('aria-selected','false');
      });

      var activeThumb = thumbsEl.querySelector('.pdp-thumb[data-index="' + index + '"]');
      if(activeThumb){ 
          activeThumb.classList.add('is-active'); 
          activeThumb.setAttribute('aria-selected','true'); 
          if(thumbs && typeof thumbs.slideTo === 'function' && !thumbs.destroyed && !thumbs.isLocked) {
              thumbs.slideTo(index);
          }
      }
    }

    function syncMode(force){
      var mode = isCarouselMode() ? 'carousel' : 'grid';
      if(!force && mode === lastMode){
        if(mode === 'carousel'){
          if(swiper) swiper.update();
          if(thumbs && typeof thumbs.update === 'function') thumbs.update();
          updateUI(swiper, (swiper && swiper.activeIndex) || 0);
        } else {
          updateUI(null, 0);
        }
        scheduleDetailsStickySync();
        return;
      }

      if(mode === 'carousel'){
        createThumbs();
        createMainSwiper();
        if(thumbs && typeof thumbs.update === 'function') thumbs.update();
        if(swiper) swiper.update();
        updateUI(swiper, (swiper && swiper.activeIndex) || 0);
      } else {
        destroySwiper(swiper);
        destroySwiper(thumbs);
        swiper = null;
        thumbs = null;
        updateUI(null, 0);
      }

      lastMode = mode;
      scheduleDetailsStickySync();
    }

    // PhotoSwipe lightbox (if available)
    function initPS() {
      try{
        var galleryEl = root.querySelector('[data-gallery]');
        if(!galleryEl) return;
        var lightbox = new window.PhotoSwipeLightbox({
          gallery: galleryEl,
          children: 'a',
          pswpModule: window.PhotoSwipe,
          // Add comfortable space around the image so it doesn't touch viewport edges
          padding: { top: 64, bottom: 64, left: 16, right: 16 },
          clickToCloseNonZoomable: true,
          // Close on image click and disable double-tap zoom
          imageClickAction: 'close',
          doubleTapAction: 'close',
          bgOpacity: 0.6,
          mainClass: 'pswp-rounded'
        });
        lightbox.init();
        root.__pswp = lightbox;

        // Intercept anchor clicks to force modal open with correct index
        var zoomLinks = root.querySelectorAll('.pdp__zoom');
        zoomLinks.forEach(function(a){
          a.addEventListener('click', function(ev){
            try{
              if(!root.__pswp) return;
              ev.preventDefault();
              var idx = parseInt(a.getAttribute('data-index'), 10) || 0;
              root.__pswp.loadAndOpen(idx);
            }catch(e){ /* fallback: allow default */ }
          });
        });
      }catch(e){ /* noop */ }
    }
    function tryInitPhotoSwipe(){
      if(ds.openLightbox !== 'true' && ds.openLightbox !== true) return;
      if(window.PhotoSwipeLightbox && window.PhotoSwipe){ initPS(); }
      else {
        // Retry after window load in case CDN scripts lag behind
        window.addEventListener('load', function(){ 
          if(window.PhotoSwipeLightbox && window.PhotoSwipe){ initPS(); }
        }, { once: true });
      }
    }
    tryInitPhotoSwipe();

    // Capture-phase click interceptor to prevent navigation to image
    root.addEventListener('click', function(ev){
      var link = ev.target && ev.target.closest && ev.target.closest('.pdp__zoom');
      if(!link) return;
      if(ds.openLightbox === 'true' || ds.openLightbox === true){
        ev.preventDefault();
        // ensure PS is ready, then open
        if(!root.__pswp && window.PhotoSwipeLightbox && window.PhotoSwipe){ initPS(); }
        var idx = parseInt(link.getAttribute('data-index'), 10) || 0;
        if(root.__pswp && typeof root.__pswp.loadAndOpen === 'function'){
          try{ root.__pswp.loadAndOpen(idx); }catch(_e){ /* swallow */ }
        }
      }
    }, true);

    if(loadMoreButton){
      loadMoreButton.addEventListener('click', function(){
        var gallery = root.querySelector('.pdp__gallery');
        if(!gallery) return;
        gallery.classList.add('is-grid-expanded');
        scheduleDetailsStickySync();
      });
    }

    if(window.ResizeObserver && galleryWrapEl && detailsEl){
      var detailsStickyObserver = new window.ResizeObserver(function(){
        scheduleDetailsStickySync();
      });
      detailsStickyObserver.observe(galleryWrapEl);
      detailsStickyObserver.observe(detailsEl);
    }

    syncMode(true);
    window.addEventListener('resize', function(){ syncMode(false); });
    window.addEventListener('load', function(){ scheduleDetailsStickySync(); }, { once: true });
  }

  document.addEventListener('DOMContentLoaded', function(){
    var roots = document.querySelectorAll('[id^="ProductInformation-"], [id^="PDPHeaderClean-"]');
    if(!roots || roots.length === 0){ return; }
    roots.forEach(function(root){
      if(root && root.querySelector('.pdp__main')){ initGallery(root); }
      // Trigger fade-in for pricing once DOM is ready
      try { setTimeout(function(){ root.classList.add('pdp--ready'); }, 0); } catch(_e){}
    });
  });
})();
